/* eslint-disable no-var */
/* eslint-disable @angular-eslint/no-output-on-prefix */
import {
  AfterContentInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import SignaturePad from 'signature_pad';

declare var require: any;

export interface Point {
  x: number;
  y: number;
  time: number;
}

export type PointGroup = Array<Point>;

@Component({
  selector: 'rx-signature',
  templateUrl: './rx-signature.component.html',
  styleUrls: ['./rx-signature.component.scss'],
  imports: [CommonModule],
})
export class RxSignatureComponent implements AfterContentInit, OnDestroy {
  private _placeholder = 'Sign here, please.';
  // eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
  @Input() public options: Object | any;
  @Output() public onBeginEvent: EventEmitter<boolean> | any;
  @Output() public onEndEvent: EventEmitter<boolean> | any;
  @Input() public placeholder = this._placeholder;
  @Output() public initialized = new EventEmitter<void>();

  public DEFAULT_EMPTY_IMAGE =
    'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
  private signaturePad: any;
  private elementRef: ElementRef;
  public hasSignature = false;

  constructor(elementRef: ElementRef) {
    // no op
    this.elementRef = elementRef;
    this.options = this.options || {};
    this.onBeginEvent = new EventEmitter();
    this.onEndEvent = new EventEmitter();
  }

  public ngAfterContentInit(): void {
    const canvas: any = this.elementRef.nativeElement.querySelector('canvas');

    canvas.width = 530;
    canvas.height = 240;

    this.signaturePad = new SignaturePad(canvas, this.options);

    this.signaturePad.addEventListener('beginStroke', this.onBegin.bind(this));
    this.signaturePad.addEventListener('endStroke', this.onEnd.bind(this));

    setTimeout(() => {
      this.setCanvasDimensions(canvas);
      this.resizeCanvas();
      this.initialized.emit();
    }, 100);
  }

  private setCanvasDimensions(canvas: any): void {
    const parentElement = canvas.parentElement;

    if ((this.options as any).canvasHeight) {
      canvas.height = (this.options as any).canvasHeight;
    } else {
      const parentHeight = parentElement
        ? parentElement.offsetHeight
        : this.elementRef.nativeElement.offsetHeight;
      canvas.height = Math.max(parentHeight, 240); // Ensure minimum height of 240px
    }

    if ((this.options as any).canvasWidth) {
      canvas.width = (this.options as any).canvasWidth;
    } else {
      canvas.width = parentElement
        ? parentElement.offsetWidth
        : this.elementRef.nativeElement.offsetWidth;
    }
  }

  public ngOnDestroy(): void {
    const canvas: any = this.elementRef.nativeElement.querySelector('canvas');
    canvas.width = 0;
    canvas.height = 0;
  }

  // public resizeCanvas(): void {
  //     const ratio: number = Math.max(window.devicePixelRatio || 1, 1);
  //     const canvas: any = this.signaturePad._canvas;
  //     canvas.width = canvas.offsetWidth * ratio;
  //     canvas.height = canvas.offsetHeight * ratio;
  //     canvas.getContext('2d').scale(ratio, ratio);
  //     this.signaturePad.clear();
  // }

  public resizeCanvas(): void {
    if (!this.signaturePad) return;

    const ratio: number = Math.max(window.devicePixelRatio || 1, 1);
    const canvas: any = this.signaturePad.canvas;

    canvas.style.width = '100%';
    canvas.style.height = '100%';

    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    canvas.getContext('2d').scale(ratio, ratio);
    this.signaturePad.clear();
  }

  public toData(): Array<PointGroup> {
    if (this.signaturePad) {
      return this.signaturePad.toData();
    } else {
      return [];
    }
  }

  public fromData(points: Array<PointGroup>): void {
    this.signaturePad.fromData(points);
  }

  public toDataURL(imageType?: string, quality?: number): string {
    return this.signaturePad.toDataURL(imageType, quality);
  }

  public fromDataURL(dataURL: string, options: any = {}): void {
    this.hasSignature = dataURL && dataURL !== this.DEFAULT_EMPTY_IMAGE;
    if (!options.hasOwnProperty('height') && (this.options as any).canvasHeight) {
      options.height = (this.options as any).canvasHeight;
    }
    if (!options.hasOwnProperty('width') && (this.options as any).canvasWidth) {
      options.width = (this.options as any).canvasWidth;
    }
    this.signaturePad.fromDataURL(dataURL, options);
  }

  public clear(): void {
    this.signaturePad.clear();
    this.placeholder = this._placeholder;
  }

  public isEmpty(): boolean {
    return this.signaturePad.isEmpty();
  }

  public off(): void {
    this.signaturePad.off();
  }

  public on(): void {
    this.signaturePad.on();
  }

  public set(option: string, value: any): void {
    switch (option) {
      case 'canvasHeight':
        this.signaturePad._canvas.height = value;
        break;
      case 'canvasWidth':
        this.signaturePad._canvas.width = value;
        break;
      default:
        this.signaturePad[option] = value;
    }
  }

  public onBegin(): void {
    this.onBeginEvent.emit(true);
  }

  public onEnd(): void {
    this.onEndEvent.emit(true);
  }

  public queryPad(): any {
    return this.signaturePad;
  }

  public onCanvasMouseDown() {
    this.placeholder = '';
  }
}
